import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { useTranslation } from 'services/localization';
import { PosTriggerType, ShopPlugins } from 'common/types';
import PosTriggerTypeSelection from './components/PosTriggerTypeSelection';

interface Props {
	teksoData: ShopPlugins['teksoPos'];
	onTeksoDataChange: (data: ShopPlugins['teksoPos']) => void;
}

const Tekso = (props: Props) => {
	const { t } = useTranslation();
	const shopReadOnlyInfo = useSelector(ShopSelectors.activeShopReadOnly);
	const teksoData = shopReadOnlyInfo?.integrations?.TEKSO;
	const teksoPosInUse =
		teksoData != null && teksoData.orderBaseNumber != null && teksoData.customerId != null;

	const handleTriggerTypesChange = async (triggerTypes: PosTriggerType[]) => {
		props.onTeksoDataChange({ triggerTypes });
	};

	return (
		<ContainerBox>
			<Grid container spacing={2}>
				<Grid item sm={12} md={6}>
					<Typography variant="h6" gutterBottom>
						{'Tekso'}
					</Typography>
					{teksoPosInUse ? (
						<Typography variant="body2" sx={{ mr: 2 }}>
							{t(
								'integrations.tekso.inUse',
								'Tekso integration in use. Please contact support if you need any changes for it.',
							)}
						</Typography>
					) : (
						<Typography variant="body2" sx={{ mr: 2 }}>
							{t(
								'integrations.tekso.missing',
								'Tekso integration credentials missing. Please contact support.',
							)}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} md={6}>
					{teksoPosInUse && (
						<PosTriggerTypeSelection
							selectedTriggerTypes={props.teksoData?.triggerTypes ?? []}
							onTriggerTypesChange={handleTriggerTypesChange}
							posType="TEKSO"
						/>
					)}
				</Grid>
			</Grid>
		</ContainerBox>
	);
};

export default Tekso;
